export type CreateUniqueValueProps<T, K = T> = {
  existing: T[];
  generate: (seed: number) => T;
  getKey?: (item: T) => K;
};

export function createUniqueValue<T, K = T>({
  existing,
  generate,
  getKey
}: CreateUniqueValueProps<T, K>): T {
  getKey ??= (item) => {
    return item as unknown as K;
  };
  const existingMap = new Map(existing.map((item) => {
    return [getKey(item), item];
  }));

  let newValue: T;
  let seed = 0;
  do {
    newValue = generate(seed);
    seed += 1;
  } while (existingMap.has(getKey(newValue)));

  return newValue;
}
